<template>
    <left-menu-block></left-menu-block>
    <section class="admin-panel-main-section trans-04 m-lf--17r p-lr-10-sm" id="adm-p-sec">
        <header-block></header-block>

        <div class="tab-content adminPanel-mainInfo-wrapper">
            <Transition enter-active-class="fade" enter-to-class="show">
                <KeepAlive>
                    <dashboard-menu v-if="$store.state.menuControl.selectedPage == 'dashboardMenu'"></dashboard-menu>
                </KeepAlive>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <users-menu v-if="$store.state.menuControl.selectedPage == 'usersMenu'"></users-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <suppliers-menu v-if="$store.state.menuControl.selectedPage == 'suppliersMenu'"></suppliers-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <partners-menu v-if="$store.state.menuControl.selectedPage == 'partnersMenu'"></partners-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <clients-menu v-if="$store.state.menuControl.selectedPage == 'clientsMenu'"></clients-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <products-menu v-if="$store.state.menuControl.selectedPage == 'productsMenu'"></products-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <KeepAlive>
                    <categories-menu v-if="$store.state.menuControl.selectedPage == 'categoriesMenu'"></categories-menu>
                </KeepAlive>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <labels-menu v-if="$store.state.menuControl.selectedPage == 'labelsMenu'"></labels-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <invoices-menu v-if="$store.state.menuControl.selectedPage == 'invoicesMenu'"></invoices-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <finances-menu v-if="$store.state.menuControl.selectedPage == 'financesMenu'"></finances-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <discounts-menu v-if="$store.state.menuControl.selectedPage == 'discountsMenu'"></discounts-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <promo-codes-menu v-if="$store.state.menuControl.selectedPage == 'promoCodesMenu'"></promo-codes-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <delivery-menu v-if="$store.state.menuControl.selectedPage == 'deliveryMenu'"></delivery-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <warehouse-menu v-if="$store.state.menuControl.selectedPage == 'warehouseMenu'"></warehouse-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <permissions-menu v-if="$store.state.menuControl.selectedPage == 'permissionsMenu'"></permissions-menu>
            </Transition>
            <Transition enter-active-class="fade" enter-to-class="show">
                <tech-dev-panel v-if="$store.state.menuControl.selectedPage == 'techDevPanel'"></tech-dev-panel>
            </Transition>
        </div>
    </section>
</template>

<script>
import leftMenuBlockVue from "./leftMenuBlock.vue"
import headerMenuBlock from "./headerBlock.vue"

import dashboardMenuVue from "./mainBlocks/dashboardMenu.vue"
import usersMenuVue from "./mainBlocks/usersMenu.vue"
import suppliersMenuVue from "./mainBlocks/suppliersMenu.vue"
import partnersMenuVue from "./mainBlocks/partnersMenu.vue"
import clientsMenuVue from "./mainBlocks/clientsMenu.vue"
import productsMenuVue from "./mainBlocks/productsMenu/main.vue"
import categoriesMenuVue from "./mainBlocks/categoriesMenu/categoriesMenu.vue"
import labelsMenuVue from "./mainBlocks/labelsMenu/labelsMenu.vue"
import invoicesMenuVue from "./mainBlocks/invoicesMenu.vue"
import financesMenuVue from "./mainBlocks/financesMenu.vue"
import discountsMenuVue from "./mainBlocks/discountsMenu.vue"
import promoCodesMenuVue from "./mainBlocks/promoCodesMenu.vue"
import deliveryMenuVue from "./mainBlocks/deliveryMenu.vue"
import warehouseMenuVue from "./mainBlocks/warehouseMenu.vue"
import permissionsMenuVue from "./mainBlocks/permissionsMenu/permissionsMenu.vue"
import techDevPanelVue from "./mainBlocks/techDevPanel.vue"

export default {
    components: {
        leftMenuBlock: leftMenuBlockVue,
        headerBlock: headerMenuBlock,
        dashboardMenu: dashboardMenuVue,
        usersMenu: usersMenuVue,
        suppliersMenu: suppliersMenuVue,
        partnersMenu: partnersMenuVue,
        clientsMenu: clientsMenuVue,
        productsMenu: productsMenuVue,
        categoriesMenu: categoriesMenuVue,
        labelsMenu: labelsMenuVue,
        invoicesMenu: invoicesMenuVue,
        financesMenu: financesMenuVue,
        discountsMenu: discountsMenuVue,
        promoCodesMenu: promoCodesMenuVue,
        deliveryMenu: deliveryMenuVue,
        warehouseMenu: warehouseMenuVue,
        permissionsMenu: permissionsMenuVue,
        techDevPanel: techDevPanelVue
    }
}
</script>

<style>

</style>